
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/my/applied",
      function () {
        return require("private-next-pages/jobs/my/applied/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/my/applied"])
      });
    }
  